import { createClient, SupabaseClient } from '@supabase/supabase-js';
import { Database } from '../data/database';

const supabaseUrl = 'https://fzyvwtjybolwqmmlotep.supabase.co';
// const supabaseUrl = 'http://localhost:8000';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImZ6eXZ3dGp5Ym9sd3FtbWxvdGVwIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Mzg1NDAwMDEsImV4cCI6MjA1NDExNjAwMX0.VtKkoJpl5IutldS-LZes6QHGuhMjdqADC9JazEhwR80';

export function getSupabaseClient(): SupabaseClient {
  const client = createClient(supabaseUrl, supabaseAnonKey);
  // Check if user is already signed in before attempting anonymous sign-in
  client.auth.getSession().then(({ data: { session } }) => {
    if (!session && !supabaseUrl.includes('localhost')) {
      // Sign in anonymously only if no active session exists
      client.auth.signInAnonymously().catch(error => {
        console.error('Error signing in anonymously:', error.message);
      });
    }
    else {
      console.log('User is already signed in:', session.user.id);
    }
  });
  return client;
}

export async function invokeSupabaseFunction<T = any>(functionName: string, payload: any): Promise<{ data: T | null; error: Error | null }> {
  const supabase = getSupabaseClient();
  try {
    const { data, error } = await supabase.functions.invoke(functionName, {
      body: payload,
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE, OPTIONS',
        'Access-Control-Allow-Headers': 'Content-Type, Authorization'
      }
    });
    return { data, error };
  } catch (error) {
    return { data: null, error: error as Error };
  }
}

// For backward compatibility
export const supabase = getSupabaseClient();

